export { default as i18n } from './lib/i18n';
